/**
 * Route for `igaming-active-player-tracking`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingActivePlayerTrackingPage } from "../features/igaming-active-player-tracking/IgamingActivePlayerTrackingPage";

export const igamingActivePlayerTrackingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-active-player-tracking",
	component: IgamingActivePlayerTrackingPage,
});

export default igamingActivePlayerTrackingRoute;
